import 'angular';
import './recent_shares.html';
import '../controllers/RecentSharesComponentController';
import '../services/RecentSharedService';

angular.module('GorillaBoy.Dboard')
.directive('recentShares', [
    () => {
    return {
        scope: true,
        templateUrl: './dboard/components/recent_shares.html',
        controller: 'RecentSharesComponentController'
    };
}]);
